import { render, staticRenderFns } from "./PsConfigurationDiseases.vue?vue&type=template&id=73e4a759&scoped=true&"
import script from "./PsConfigurationDiseases.vue?vue&type=script&lang=js&"
export * from "./PsConfigurationDiseases.vue?vue&type=script&lang=js&"
import style0 from "./PsConfigurationDiseases.vue?vue&type=style&index=0&id=73e4a759&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e4a759",
  null
  
)

export default component.exports